import {
    ACTION_GET_PURCHASERECONCILIATION,
    SET_PURCHASERECONCILIATION,

    ACCION_GET_CHANGESTATE_LIST_TYPE_STATE,
    SET_CHANGESTATE_LIST_TYPE_STATE,

    ACTION_POST_CHANGESTATE,
} from "@/views/purchase_reconciliation/store/types/types.js"


import Swal from "sweetalert2";
import { PurchaseReconciliationService } from "../../../services";

const actions = {

    [ACTION_GET_PURCHASERECONCILIATION]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                PurchaseReconciliationService.getPurchaseReconciliation(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const purchaseReconciliation = resp.data.payload.map((e, i) => ({
                                ...e,
                                activeDialogClient: false,
                                index: i
                            }));
                            commit(SET_PURCHASERECONCILIATION, purchaseReconciliation);
                            resolve(resp.data.payload);

                        } else {
                            console.error("La respuesta no tiene un formato esperado:", resp);
                            reject("La respuesta no tiene un formato esperado");
                        }
                    })
                    .catch(err => {
                        console.error("Error en la solicitud de proveedores:", err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error("Error en la solicitud de proveedores:", error);
                reject(error);
            }
        });
    },

    [ACCION_GET_CHANGESTATE_LIST_TYPE_STATE]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loadingUser = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                PurchaseReconciliationService.getTypeChangeState(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const typeChangeState = resp.data.payload.map((e, i) => ({
                                ...e,
                                activeDialogClient: false,
                                index: i
                            }));
                            commit(SET_CHANGESTATE_LIST_TYPE_STATE, typeChangeState);
                            resolve(resp.data.payload);

                        } else {
                            console.error("La respuesta no tiene un formato esperado:", resp);
                            reject("La respuesta no tiene un formato esperado");
                        }
                    })
                    .catch(err => {
                        console.error("Error en la solicitud del estado:", err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loadingUser = false;
                    });
            } catch (error) {
                console.error("Error en la solicitud del estado:", error);
                reject(error);
            }
        });
    },


    [ACTION_POST_CHANGESTATE]: async ({ state }, postChangeState) => {

        return await new Promise((resolve, reject) => {
            state.loading = true;
            const idGroup = sessionStorage.getItem("idGroup");
            const idEmpresa = sessionStorage.getItem("idEmpresa");
            const idUsuario = sessionStorage.getItem("idUsuario");

            PurchaseReconciliationService.postChangeState({ idGroup, idEmpresa, idUsuario, postChangeState })
                .then(async (resp) => {
                    if (resp && resp.status === 200) {
                        await Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: resp.data.payload.message,
                            showConfirmButton: false,
                            timer: 2500
                        });
                        resolve(resp);
                        window.location.reload();
                    } else {
                        reject("La petición fue incorrecta o falló");
                    }
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => state.loading = false);
        });
    },
}

export default actions;